import { TRiskQuestions } from '../../models/riskQuestions.model';
import { currencyFormatterWithDecimals } from '@assetmark/utilities/';
import { ERiskPageType } from '../../models/riskPageType';

export const countMaxDecline = (
  InvestmentAmount: number,
  percentage: number,
) => {
  return (Math.abs(percentage) * InvestmentAmount) / 100;
};
export const formatLabel = (Amount: number) => {
  return '-$' + currencyFormatterWithDecimals(Amount);
};
export const GetRiskQuestions = (QuestionType): TRiskQuestions => {
  const riskQuestions = {
    [ERiskPageType.MaximumDecline]: {
      Heading: 'Maximum Decline',
    },
    [ERiskPageType.StockMarketForecast]: {
      Heading: 'Stock Market Forecast',
    },
    [ERiskPageType.AgeRange]: {
      Heading: 'Your Age Range',
    },
    [ERiskPageType.PlannedWithdrawal]: {
      Heading: 'Planned Withdrawal',
    },
    [ERiskPageType.RiskTolerance]: {
      Heading: 'Risk Tolerance',
    },
    [ERiskPageType.TimeHorizon]: {
      Heading: 'Time Horizon',
    },
    [ERiskPageType.InvestmentPercentage]: {
      Heading: 'Investment Percentage',
    },
    [ERiskPageType.YourRiskProfile]: {
      Heading: 'Your Risk Profile',
    },
  };

  return riskQuestions[QuestionType];
};
